import axios from "../axios";

export const getAllManagers = async() => {
   
   const {data} = await axios.get('managers')
  
   return data
}